import { styled } from '@mui/material';

export const HeaderContainer = styled('div')(({ theme }) => ({
  margin: theme.spacing(3, 0, 3, 0),
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between'
}));
